// @ts-nocheck
/* eslint-disable */
import { createFilterButton } from '~/ui/filterbutton';
import { text } from '~/util/dom';
import SelectBox from './selectbox';

/**
 * @private
 */
export default class Filters {
	constructor(data, activeFilters) {
		this._node = Mapy.Util.node("div", { className: "search-filters" });
		this._data = data;
		this._selects = [];
		this._checkboxes = [];
		this._cb = null;

		if (data.length) {
			this._build(activeFilters);
		}
	}

	destroy() {
		this._node.remove();

		this._selects.forEach(s => {
			s.destroy();
		});
		this._selects = [];

		this._checkboxes.forEach(ch => {
			ch.removeEventListener("change", this, false);
		});
		this._checkboxes = [];

		this._cb = null;
	}

	get node() {
		return this._node;
	}

	set cb(fc) {
		this._cb = fc;
	}

	handleEvent(event) {
		for (let i = 0; i < this._checkboxes.length; i++) {
			let label = this._checkboxes[i];

			if (event.target === label || label.contains(event.target)) {
				let input = label.querySelector("input");
				label.classList[input.checked ? "add" : "remove"]("active");

				this._cb && this._cb({
					id: input.value,
					type: input.dataset.type,
					name: input.value,
					on: input.checked,
				});
			}
		}
	}

	_build(activeFilters) {
		this._data.forEach(d => {
			switch(d.frontendType) {
				case "selectbox":
					let select = new SelectBox(d);
					select.cb = (change) => {
						this._cb && this._cb(change);
					};

					if (activeFilters[d.type]) {
						select.select = activeFilters[d.type].id;
					}

					this._node.appendChild(select.node);

					this._selects.push(select);
					break;

				case "button":
					const label = createFilterButton({
						checked: !!activeFilters[d.id],
						label: text(d.label),
						value: d.id,
						type: d.type,
					});

					label.addEventListener("change", this, false);
					this._node.appendChild(label);
					this._checkboxes.push(label);

					break;
			}
		});
	}
}
